import { getApiClient } from '@src/shared/types/api-client'
import type { ImportCreditAppRequest, ImportCreditAppResult } from '@src/tools/anonymizer/types/Constants'
import { useMutation } from '@tanstack/react-query'

export function useImportCreditApp() {
  const { mutate, isPending, isError, reset, data, error } = useMutation({
    mutationFn: async (params: ImportCreditAppRequest): Promise<ImportCreditAppResult> => {
      const apiClient = getApiClient()
      const response = await apiClient.post<ImportCreditAppResult>('import-credit-app', params)
      return response.data
    },
  })
  return [mutate, isPending, isError, reset, data, error] as const
}
